module.exports = __webpack_public_path__ + "media/images/marketing/blog1-e834dd38bbc9408b445bc4448efedfc687c8fe26e44d3dd65ef9979c97e347fa.jpg";